/* eslint-disable react/no-unescaped-entities */

import React from 'react'

import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => {
  const classList = {
    paper: {
      margin: theme.spacing(16, 4)
    },
    paragraph:
    {
      marginTop: 0,
      marginRight: 0,
      marginBottom: '8.0pt',
      marginLeft: 0,
      fontSize: 14
    }
  }
  return classList
})

const Clarification = () => {
  const classes = useStyles()
  return (
    <>
      <Grid container component="main">
        <Grid item xs={12}>

          <div className={classes.paper}>

            <p className={classes.paragraph}>
              <b>
                <span>
                  KİŞİSEL VERİLERİN KORUNMASI KANUNU UYARINCA
                  AYDINLATMA METNİ
                </span>
              </b>
            </p>

            <p className={classes.paragraph}>
              <span>
                İşbu Kişisel Verilerin Korunması Kanunu
                Uyarınca Aydınlatma Metni (“Aydınlatma Metni”) veri sorumlusu sıfatıyla hareket
                eden KOLAYYOLLA TEKNOLOJİ HİZMETLERİ DİJİTAL PAZARLAMA VE TİCARET ANONİM
                ŞİRKETİ (“KolayYolla”) tarafından KolayYolla 6698 sayılı Kişisel Verilerin
                Korunması Kanunu’na (“Kanun”) uygun olarak Kolay yolla kullanıcılarının ve
                Müşterilerinin kişisel verilerinin işlenmesine ilişkin açıklamalarda bulunmak
                ve bilgilendirmek amacıyla kaleme almıştır.
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                KolayYolla ile paylaştığınız kişisel verilerinizin
                işlenmesine ilişkin daha detaylı bilgiye ana sayfamız üzerinde yer alan KolayYolla
                Gizlilik Politikasından ulaşabilirsiniz.
              </span>
            </p>

            <p className={classes.paragraph}><b><span>&nbsp;</span></b></p>

            <p className={classes.paragraph}><b><span>1. Toplanan Kişisel Veriler</span></b></p>

            <p className={classes.paragraph}>
              <span>
                KolayYolla ile olan hukuki ilişkiniz
                kapsamında paylaştığınız verileriniz Profil(Kimlik), İletişim,&nbsp; Konum,
                İşlem, İşlem Güvenliği, Finansal, Pazarlama, Talep/ Şikayet Yönetimi
                kategorilerinde sınıflandırılmıştır.
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Kişilerin ırkı, etnik kökeni, siyasi
                düşüncesi, felsefi inancı, dini, mezhebi veya diğer inançları, kılık ve
                kıyafeti, dernek, vakıf ya da sendika üyeliği, sağlığı, cinsel hayatı, ceza
                mahkûmiyeti ve güvenlik tedbirleriyle ilgili verileri ile biyometrik ve genetik
                verileri özel nitelikli kişisel veridir. KolayYolla herhangi bir şekilde özel
                nitelikli kişisel verilerinizi toplamaz ve işlemez. Bu gibi verileri
                paylaşmanızı istemeyiz. KolayYolla ile ilişkiniz kapsamında hangi etkileşim
                yoluyla olursa olsun özel nitelikli kişisel verilinizi paylaşmayınız.
              </span>
            </p>

            <p className={classes.paragraph}><b><span>&nbsp;</span></b></p>

            <p className={classes.paragraph}><b><span>2. Kişisel Verilerin İşlenme Amacı</span></b></p>

            <p className={classes.paragraph}>
              <span>
                Yukarıda belirtilen kişisel verileriniz
                aşağıdaki amaçlar doğrultusunda ve bunlarla sınırlı ve ölçülü olacak şekilde
                işlenecektir.
              </span>
            </p>

            <p className={classes.paragraph}><b><span>&nbsp;</span></b></p>

            <p className={classes.paragraph}>
              <b>
                <span>
                  i.&nbsp; &nbsp; &nbsp;Şirket tarafından
                  sunulan hizmete ilişkin sözleşmenin yerine getirilebilmesi kapsamında;
                </span>
              </b>
            </p>

            <ul>
              <li className={classes.paragraph}><span>Siparişinizin tarafınıza iletilebilmesi</span></li>
              <li className={classes.paragraph}>
                <span>
                  KolayYolla ile kurmuş olduğunuz sözleşmenin
                  ifası
                </span>
              </li>
              <li className={classes.paragraph}><span>Sözleşmenin diğer süreçlerinin takibi</span></li>
            </ul>

            <p className={classes.paragraph}><b><span>&nbsp;</span></b></p>

            <p className={classes.paragraph}>
              <b>
                <span>
                  ii.&nbsp; &nbsp; Şirket tarafından sunulan
                  ürün ve hizmetlerin kullanıcı deneyiminin arttırılması için ve ilgili kişilerin
                  beğeni, kullanım alışkanlıkları ve ihtiyaçlarına göre özelleştirilerek ilgili
                  kişilere önerilmesi ve tanıtılması için gerekli olan aktivitelerin planlanması
                  ve icrası kapsamında;
                </span>
              </b>
            </p>

            <ul>
              <li className={classes.paragraph}>
                <span>
                  Kullanıcı memnuniyeti aktivitelerinin
                  planlanması ve/veya icrası
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Ürün ve hizmetlerin satış ve pazarlaması
                  için pazar araştırması faaliyetlerinin planlanması ve icrası
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Ürün ve/veya hizmetlerin pazarlama
                  süreçlerinin planlanması ve icrası
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Şirketin sunduğu ürün veya hizmetlerden en
                  yüksek faydanın elde edilmesi, kullanıcı deneyiminin artırılması için
                  ilgili süreçlerin planlanması ve icrası ve bu kapsamda KolayYolla
                  tarafından anlık bildirimlerin yapılması, kullanıcı alışkanlıklarının
                  tespit edilerek hedefleme, profilleme ve analizlerin yapılması, tarafınıza
                  indirimli kampanya sunulması, özelleştirilmiş içeriklerin sunulması,
                  dijital pazarlama, hedefleme, yeniden pazarlama (
                  <i>on-site remarketing</i>
                  ),reklam
                  yapılması
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Satış, pazarlama ve optimizasyon
                  süreçlerinin&nbsp;kullanıcı deneyimini iyileştirmek&nbsp;için planlanması
                  ve icrası
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Şirket iş ve stratejilerine ilişkin
                  süreçlerin planlanması ve geliştirilmesi kapsamında tarafınıza yapılan
                  reklamlara ilişkin değerlendirme, analiz ve kullanıcı deneyiminin
                  geliştirilmesi için optimizasyon faaliyetlerinin yapılması,
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Şirketin sunduğu ürün ve hizmetlerin satış
                  ve pazarlaması için pazar araştırması faaliyetlerinin planlanması ve
                  icrası kapsamında pazar araştırmaları ve anketlerin yapılması
                </span>
              </li>
            </ul>

            <p className={classes.paragraph}><span>&nbsp;</span></p>

            <p className={classes.paragraph}>
              <b>
                <span>
                  iii.&nbsp; &nbsp; Şirket tarafından sunulan
                  ürün ve hizmetlerden ilgili kişileri faydalandırmak ve bu kullanıcıların
                  deneyiminin arttırılması için gerekli çalışmaların iş birimlerimiz tarafından
                  yapılması ve ilgili iş süreçlerinin yürütülmesi kapsamında;
                </span>
              </b>
            </p>

            <ul>
              <li className={classes.paragraph}>
                <span>
                  Ürün ve/veya hizmetlerin satış süreçlerinin
                  planlanması ve icrası
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Satış sonrası destek hizmetleri
                  aktivitelerinin planlanması ve/veya icrası
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Kullanıcı ilişkileri yönetimi süreçlerinin
                  planlanması ve icrası
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Kullanıcı talep ve/veya şikayetlerinin
                  takibi
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Sözleşme süreçlerinin ve/veya hukuki
                  taleplerin takibi
                </span>
              </li>
            </ul>

            <p className={classes.paragraph}><b><span>&nbsp;</span></b></p>

            <p className={classes.paragraph}>
              <b>
                <span>
                  iv.&nbsp; &nbsp; Şirket'in ve Şirket'le iş
                  ilişkisi içerisinde olan ilgili kişilerin hukuki, teknik ve ticari iş
                  güvenliğinin temin edilmesi kapsamında;
                </span>
              </b>
            </p>

            <ul>
              <li className={classes.paragraph}>
                <span>
                  Şirket denetim faaliyetlerinin planlanması
                  ve icrası
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Şirket faaliyetlerinin şirket prosedürleri
                  ve/veya ilgili mevzuata uygun olarak yürütülmesinin temini için gerekli
                  operasyonel faaliyetlerin planlanması ve icrası
                </span>
              </li>
              <li className={classes.paragraph}><span>Şirket operasyonlarının güvenliğinin temini</span></li>
              <li className={classes.paragraph}>
                <span>
                  Verilerin doğru ve güncel olmasının
                  sağlanması
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Yetkili kuruluşlara mevzuattan kaynaklı
                  bilgi verilmesi
                </span>
              </li>
            </ul>

            <p className={classes.paragraph}><b><span>&nbsp;</span></b></p>

            <p className={classes.paragraph}>
              <b>
                <span>
                  v.&nbsp; &nbsp; Şirket tarafından yürütülen
                  ticari faaliyetlerin gerçekleştirilmesi için ilgili iş birimlerimiz tarafından
                  gerekli çalışmaların yapılması ve buna bağlı iş süreçlerinin yürütülmesi
                  kapsamında;
                </span>
              </b>
            </p>

            <ul>
              <li className={classes.paragraph}>
                <span>
                  Bilgi güvenliği süreçlerinin planlanması,
                  denetimi ve icrası
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Bilgi teknolojileri alt yapısının
                  oluşturulması ve yönetilmesi
                </span>
              </li>
              <li className={classes.paragraph}><span>Finans ve/veya muhasebe işlerinin takibi</span></li>
              <li className={classes.paragraph}><span>Hukuk işlerinin takibi</span></li>
              <li className={classes.paragraph}><span>İşfaaliyetlerininetkinlik/verimlilikve/veyayerindelikanalizleriningerçekleştirilmesifaaliyetlerininplanlanmasıve/veyaicrası</span></li>
              <li className={classes.paragraph}><span>İş faaliyetlerinin planlanması ve icrası</span></li>
              <li className={classes.paragraph}>
                <span>
                  Kurumsal iletişim faaliyetlerinin
                  planlanması ve icrası
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Lojistik faaliyetlerinin planlanması ve
                  icrası
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Üretim ve/veya operasyon süreçlerinin
                  planlanması ve icrası
                </span>
              </li>
              <li className={classes.paragraph}><span>Hileli faaliyetlerin önüne geçilmesi</span></li>
            </ul>

            <p className={classes.paragraph}><b><span>&nbsp;</span></b></p>

            <p className={classes.paragraph}>
              <b>
                <span>
                  vi.&nbsp; &nbsp; Şirket'in ticari ve/veya
                  iş stratejilerinin planlanması ve icrası kapsamında;
                </span>
              </b>
            </p>

            <ul>
              <li className={classes.paragraph}>
                <span>
                  İş ortakları ve/veya tedarikçilerle olan
                  ilişkilerin yönetimi
                </span>
              </li>
              <li className={classes.paragraph}><span>Stratejik planlama faaliyetlerinin icrası</span></li>
              <li className={classes.paragraph}><span>İşortaklarıve/veyatedarikçilerinperformansdeğerlendirmesüreçlerininplanlanmasıvetakibi</span></li>
              <li className={classes.paragraph}>
                <span>
                  Şirketin iş ve stratejilerine ilişkin
                  süreçlerin planlanması
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Performans yönetimi süreçlerinin planlanması
                  ve icrası
                </span>
              </li>
            </ul>

            <p className={classes.paragraph}><b><span>&nbsp;</span></b></p>

            <p className={classes.paragraph}>
              <b>
                <span>
                  3.&nbsp; Kişisel Veri Toplamanın Yöntemi ve
                  Hukuki Sebebi
                </span>
              </b>
            </p>

            <p className={classes.paragraph}>
              <span>
                Kişisel verileriniz KolayYolla tarafından
                e-mail, ilgili internet siteleri ve mobil uygulama gibi kanallardan,
                KolayYolla’nın erişimine imkan verdiğiniz sosyal medya hesapları üzerinden
                elektronik ortamda ve çağrı merkezi kanalı ile veya fiziki olarak posta/kargo
                yolu ile toplanmaktadır.
              </span>
            </p>

            <p className={classes.paragraph}><span>&nbsp;</span></p>

            <p className={classes.paragraph}>
              <span>
                Kişisel verileriniz işbu Aydınlatma Metni’nin
                2. maddesinde belirtilen amaçlar doğrultusunda Kanun'un 5. maddesinde
                belirtilen aşağıdaki hukuki sebeplere dayanılarak işlenebilecektir:
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Kanunlarda açıkça öngörülmesi:&nbsp;
                <b>
                  iii,
                  iv, v
                </b>
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Sizinle aramızdaki sözleşmenin kurulması veya
                ifasıyla doğrudan doğruya ilgili olması kaydıyla, size ait kişisel verilerinizi
                işlenmesinin gerekli olması:&nbsp;
                <b>i, iii, v</b>
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Hukuki yükümlülüklerimizi yerine
                getirebilmemiz için zorunlu olması:&nbsp;
                <b>iii, iv, v</b>
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Sizin tarafınızdan alenileştirilmiş olması
                (alenileştirme amacınızla bağdaştığı ölçüde):&nbsp;
                <b>ii, iii</b>
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Bir hakkın tesisi, kullanılması veya korunması
                için kişisel verilerinizi işlemenin zorunlu olması:&nbsp;
                <b>iii, iv, v</b>
              </span>
            </p>

            <p className={classes.paragraph}>
              <span>
                Temel hak ve özgürlüklerinize zarar vermemek
                kaydıyla, meşru menfaatlerimiz için zorunlu olması:&nbsp;
                <b>ii, iii, iv, v, iv</b>
              </span>
            </p>

            <p className={classes.paragraph}><span>&nbsp;</span></p>

            <p className={classes.paragraph}>
              <b>
                <span>
                  4.&nbsp; Kişisel Verilerin Aktarılabileceği
                  Taraflar ile Aktarım Amacı
                </span>
              </b>
            </p>

            <p className={classes.paragraph}>
              <span>
                KolayYolla tarafından toplanan kişisel
                verileriniz yukarıda Aydınlatma Metni’nin 2. maddesinde detayları verilen
                amaçlarla ve 3. maddede belirtilen hukuki sebeplere dayanılarak Kanun'un 8.
                maddesi uyarınca yurt içindeki iştiraklerimiz, hissedarlarımız, iş ortaklarımız,
                kanunen yetkili kamu kurumları ve özel kişiler ile paylaşılabilecektir. Aynı
                amaçlar doğrultusunda ve bunlarla sınırlı olarak kişisel verileriniz açık
                rızanız ile Kanun’un 9. maddesi uyarınca yurtdışındaki iştiraklerimiz,
                hissedarlarımız ve iş ortaklarıyla paylaşılabilecektir.
              </span>
            </p>

            <p className={classes.paragraph}><span>&nbsp;</span></p>

            <p className={classes.paragraph}>
              <b>
                <span>
                  5.&nbsp; Kişisel Verilerinize İlişkin
                  Haklarınız
                </span>
              </b>
            </p>

            <p className={classes.paragraph}>
              <span>
                Kanun’un 11. maddesi kapsamında kişisel
                verilerinize ilişkin olarak sizlere aşağıda belirtilen haklar tanınmıştır:
              </span>
            </p>

            <ul>
              <li className={classes.paragraph}>
                <span>
                  Kişisel verilerinizin işlenip işlenmediğini
                  öğrenme,
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Kişisel verileriniz işlenmişse buna ilişkin
                  bilgi talep etme,
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Kişisel verilerinin işlenme amacını ve
                  bunların amacına uygun kullanılıp kullanılmadığını öğrenme,
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Yurt içinde veya yurt dışında kişisel
                  verilerinizin aktarıldığı üçüncü kişileri bilme,
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Kişisel verilerinizin eksik veya yanlış
                  işlenmiş olması hâlinde bunların düzeltilmesini isteme ve bu kapsamda
                  yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere
                  bildirilmesini isteme,
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  6698 sayılı Kanun ve ilgili diğer kanun
                  hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren
                  sebeplerin ortadan kalkması hâlinde kişisel verilerinizin silinmesini veya
                  yok edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin
                  aktarıldığı üçüncü kişilere bildirilmesini isteme,
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  İşlenen verilerinizin münhasıran otomatik
                  sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun
                  ortaya çıkmasına itiraz etme,
                </span>
              </li>
              <li className={classes.paragraph}>
                <span>
                  Kişisel verilerinizin kanuna aykırı olarak
                  işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep
                  etme.
                </span>
              </li>
            </ul>

            <p className={classes.paragraph}><span>&nbsp;</span></p>

            <p className={classes.paragraph}>
              <span>
                KolayYolla ile paylaştığınız kişisel
                verilerinizin işlenmesine ilişkin daha detaylı bilgiye ana sayfamız üzerinde
                yer alan KolayYolla Gizlilik Politikasından erişebilirsiniz.
              </span>
            </p>

            <p className={classes.paragraph}><span>&nbsp;</span></p>

            <p className={classes.paragraph}>
              <span>
                Kişisel veri sahipleri olarak, haklarınıza
                ilişkin Kişisel Verilerin Korunması ve Gizlilik Politikası uyarınca&nbsp;
                <a
                  href="mailto:info@kolayyolla.com.tr"
                >
                  info@kolayyolla.com.tr
                </a>
                &nbsp;adresine
                iletebilirsiniz. Kişisel Verileri Koruma Kurumu tarafından ilgili mevzuat
                kapsamında belirlenen şartları taşımayan başvurular, şartları karşılaması için
                sizden talep edilebilecek ek bilgi tamamlanmadığı müddetçe, değerlendirmeye
                alınmayacaktır.
              </span>
            </p>

            <p className={classes.paragraph}><span>&nbsp;</span></p>

            <p className={classes.paragraph}>
              <span>
                KolayYolla talebin niteliğine göre talebi en
                kısa sürede ve/veya en geç otuz gün içinde ücretsiz olarak sonuçlandıracaktır.
                Bununla birlikte taleplerinizin yerine getirilmesi nedeniyle ek bir maliyet
                doğması hâlinde Kişisel Verileri Koruma Kurulunca belirlenen tarifedeki ücretin
                talep edilebileceğini hatırlatmak isteriz.
              </span>
            </p>

            <p className={classes.paragraph}><span>&nbsp;</span></p>

            <p className={classes.paragraph}>
              <span>
                KolayYolla’nın işbu Aydınlatma Metni’ni, iş
                gereksinimleri, kanuni gereksinimler doğması halinde tek taraflı olarak
                güncelleme hakkı saklıdır. Bu metnin en güncel haline ulaşmak için ana
                sayfamızı düzenli olarak ziyaret etmenizi öneririz.
              </span>
            </p>

          </div>
        </Grid>

      </Grid>

    </>
  )
}
export default Clarification
